<template>
  <v-container
    fluid
    style="margin-top: -24px;"
  >
    <v-row class="header-container pt-0 contentHeading" style="margin-left: -24px !important; margin-right: -24px !important">
      <v-col cols="12" style="align-self: center;">
        <span class="pl-3 pr-1" v-if="pageIcon"><v-icon class="mt-n3 material-icons-outlined" style="color:#FFFFFF;font-size:32px;">{{this.pageIcon}}</v-icon></span>
        <span style="color: #FFFFFF;" class="pl-3 pr-1 display-1 font-weight-bold">{{header}}</span>
        <v-btn icon dark class="pl-3 mb-2" style="color:#6BACE4" v-if="showInfo" @click="open">
          <v-icon class="material-icons-outlined">info</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" persistent width="500" @keydown.esc="close">
      <v-card :outlined="true" :raised="true">
        <div style="display: flex;">
          <v-spacer/>
          <v-btn icon @click="close" class="mt-3 mr-3">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-title primary-title class="mb-2 pt-0" style="color: #041E42;">
          About this page - {{header}}
        </v-card-title>

        <v-card-text class="body-1 pb-2" v-html="content" style="color: #041E42;">
          {{content}}
        </v-card-text>

        <v-card-actions class="pt-2 pr-6 pb-6">
          <v-spacer></v-spacer>
          <v-btn depressed color="primary darken-1" @click="close" class="text-none"
                 style="width: 120px; height: 50px; font-size: 16px; font-weight: bold;">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
  export default {
    name: "Header",
    props: {
      pageIcon: String,
      header: String,
      sitecode: [String,Number],
      content: String,
      showInfo : {
        type : Boolean,
        default: true
      }
    },
    data() {
      return {
        dialog: false,
      }
    },
    methods: {
      open() {
        this.$ga.event({
          eventCategory: `${this.header}`,
          eventAction:  `Header click`,
          eventLabel: `sitecode:${this.sitecode}`
        });
        this.dialog = true;
      },
      close() {
        this.dialog = false;
      },
    }
  }
</script>

<style scoped>
  .header-container {
    background-image: url(../../assets/doe-bg.png);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    height: 120px;
  }
</style>
